import * as localforage from "localforage";
import { phpRequest } from "./phpRequest";
import { setToken } from "./getToken";

export const authLogin = async (ticket) => {
  // const email = user.email;
  // const password = user.password;
  //const history = useHistory();

  //     'Content-Type': 'application/x-www-form-urlencoded',
  //     'Content-Type': 'application/json'

  const loginData = await phpRequest.get("/member/login", {
    ticket,
  });

  if (loginData) {
    setToken(loginData.token);
    localStorage.setItem('lastLoginTime', Date.now());
    await localforage.setItem("token", loginData.token);
    await localforage.setItem("expiredAt", loginData.expires_at); // expired date time: UTC
    await localforage.setItem("loginData", loginData);
    await localforage.setItem("user", loginData.user);
    await localforage.setItem("userCompanyID", loginData.user.company_id);
    await localforage.setItem(
      "userRole",
      loginData.user.roles.length > 0 ? loginData.user.roles[0].name : ""
    );
    await localforage.setItem(
      `${loginData.user.company_id}`,
      loginData.user.company
    );
    await localforage.setItem(
      "userCompanyImgLink",
      loginData.user.company.company_image_link
        ? loginData.user.company.company_image_link
        : ""
    );
    await localforage.setItem("userCompanyName", loginData.user.company.name);
    await localforage.setItem(
      "userCompanyContactPerson",
      loginData.user.company.contact_person
    );
    await localforage.setItem("userCompanyEmail", loginData.user.company.email);
    await localforage.setItem(
      "visioPayload",
      loginData.visio_login_url.split("payload=")[1]
    );
    await localforage.setItem(
      "vergoPayload",
      loginData.vergo_login_url.split("payload=")[1]
    );

    await localforage.setItem(
      "userDefaultCompanyCountryId",
      loginData.user.company.country_id
    )

    //store user permissions name array
    const userPermissionsFromResponse = loginData.user.roles[0].permissions;
    if (userPermissionsFromResponse) {
      const userPermissionsNameArray = userPermissionsFromResponse.map(
        (userPermissionFromResponse) => {
          return userPermissionFromResponse.name;
        }
      );
      let userPermissionsNameArrayFilter = userPermissionsNameArray.filter(
        (userPermissionName) => {
          // 只有伍豐的admin才有导入设备按鈕
          // if(userPermissionName == "device_and_groups_import" && loginData.user.company_id != '83a53790-aaf0-4c3e-b605-f1702c5004cb'){
          //   return false
          // }
          // 单独限制企业设备上传的权限
          if(userPermissionName == "device_and_groups_import" && loginData.is_can_upload !== 1){
            return false
          }
          return true
        }
      );
      await localforage.setItem("userPermissions", userPermissionsNameArrayFilter);
    }
    return true;
  } else {
    //Request is Completed, but don't get loginData.
    console.log("Failed to get loginData");
    return false;
  }
};
